export default __webpack_public_path__ + "static/media/dreadarchmagearchmagus.4858f1be.png";